<template>
  <div v-loading='loading' class="content-two">
  <div class="container-result">
      <!-- 列表 -->
      <!-- v-infinite-scroll="load" -->
      <ul
        class="list infinite-list"
        v-infinite-scroll="load"
        style="overflow: auto"
      >
        <li
          class="item infinite-list-item"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="item-content" v-if="item.project || item.plan || item.result">
            <div class="item_header">
              <div class="item_header_title">
                {{ item.name }}
              </div>
              <div class="item_header_logo">
                <img :src="item.iconUri + '?x-oss-process=style/avatar'" />
              </div>
            </div>
            <div class="item_describe">
              <span class="item_describe_tag" v-if="item.modus">{{
                modusList[item.modus - 1].name
              }}</span
              ><span class="item_describe_tag2">{{ item.universityName }}</span>
              <span class="item_describe_tag2" v-if="item.tagName"
                ># {{ item.tagName }}</span
              >
            </div>
            <div
              class="item_honor"
              v-if="item.achievements && item.achievements.length"
            >
              <span
                v-for="(item2, index2) in item.achievements"
                :key="index2"
                :class="index2 == 0 ? 'no_border' : ''"
                >{{ item2.name }} * {{ item2.num }}</span
              >
            </div>
            <!-- :class="item.project ? '' : 'nonactivated'" -->
            <div class="item_footer" v-if="item.project || item.plan || item.result">
              <!-- 展示三个按钮的样式 -->
              <div class="boxThree" v-if="item.project && item.plan && item.result">
                <div
                  v-if="item.project"
                  class="item_footer_item"
                  @click="toTask(item.project, 'project')"
                >
                  实践计划
                </div>
                <div
                  v-if="item.plan"
                  class="item_footer_item"
                  @click="toTask(item.plan, 'plan')"
                >
                  实践历程
                </div>
                <div
                  v-if="item.result"
                  class="item_footer_item"
                  @click="toTask(item.result, 'result')"
                >
                  结项成果
                </div>
              </div>
              <!-- 展示2个按钮的样式 -->
              <div class="boxTwo" v-else-if="(((item.project && item.plan) && !item.result)) || (((item.project && item.result) && !item.plan)) || (((item.plan && item.result) && !item.project))">
                <div
                  v-if="item.project"
                  class="item_footer_item"
                  @click="toTask(item.project, 'project')"
                >
                  实践计划
                </div>
                <div
                  v-if="item.plan"
                  class="item_footer_item"
                  @click="toTask(item.plan, 'plan')"
                >
                  实践历程
                </div>
                <div
                  v-if="item.result"
                  class="item_footer_item"
                  @click="toTask(item.result, 'result')"
                >
                  结项成果
                </div>
              </div>
              <!-- 展示1个按钮的样式 -->
              <div class="boxOne" v-else-if="item.project || item.plan || item.result">
                <div
                  v-if="item.project"
                  class="item_footer_item"
                  @click="toTask(item.project, 'project')"
                >
                  实践计划
                </div>
                <div
                  v-if="item.plan"
                  class="item_footer_item"
                  @click="toTask(item.plan, 'plan')"
                >
                  实践历程
                </div>
                <div
                  v-if="item.result"
                  class="item_footer_item"
                  @click="toTask(item.result, 'result')"
                >
                  结项成果
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
   
    <div class="shade_pop animate__animated animate__fadeIn" v-if="modal"></div>
    <div class="log_modal" v-if="logModal">
      <img
        class="log_close"
        src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110291045042331.svg"
        alt=""
        @click="closeLog"
      />
      <practicePlan v-if="isShow == 1" :plan="id"></practicePlan>
      <schedule v-else-if="isShow == 2" :project="id"></schedule>
      <finalResults v-else-if="isShow == 3" :result="id"></finalResults>
    </div>
  </div>
  </div>
</template>
<script>
import practicePlan from "../components/practicePlan.vue";
import schedule from "../components/schedule.vue";
import finalResults from "../components/finalResults.vue";
export default {
  data() {
    return {
      loading:false,
      current: 1,
      list: [],
      logModal: false,
      modal: false,
      isShow: 0,
      id: "",
      // tagId: 1,
      tagId:this.$route.query.tagId,
      // ppcId: 17958,
      ppcId: this.$route.query.ppcId,
      modusList: [
        {
          name: "调研",
          id: 1,
        },
        {
          name: "宣讲",
          id: 2,
        },
        {
          name: "服务",
          id: 3,
        },
        {
          name: "支教",
          id: 4,
        },
        {
          name: "义演",
          id: 5,
        },
        {
          name: "实习",
          id: 6,
        },
        {
          name: "重置",
          id: 0,
        },
      ],
    };
  },

  components: { practicePlan, schedule, finalResults },
  mounted() {
    
    this.loadList();
  },
  methods: {

    // 获取列表
    loadList() {
      this.loading=true;
      let params = {
        current: this.current,
        size: 10,
        ppcId: this.ppcId,
        tagId:this.tagId,
      };
      this.$api.social.getTeamProjectResult(params).then((res) => {
        // this.list=res.data.records;
        this.loading=false;
        this.list = this.list.concat(res.data.records);
        this.$forceUpdate;
      });
    },
    // 跳转 全程任务
    toTask(id, type) {
      if (id) {
        this.logModal = true;
        this.modal = true;
        this.id = id;
        if (type == "project") {
          this.isShow = 1;
        } else if (type == "plan") {
          this.isShow = 2;
        } else {
          this.isShow = 3;
        }
      }
    },
    //关闭弹层
    closeLog() {
      this.logModal = false;
      this.modal = false;
    },
    load() {
      this.current += 1;
      this.loadList();
    },
  },
  filters: {
    userNums(num) {
      return num < 10000 ? num : (num / 10000).toFixed(1) + "W";
    },
  },
};
</script>
<style lang="scss" scoped>
.container-result {
    .list {
        // height: 100vh;
        max-height: 4.16667rem;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        // flex-wrap: wrap;
        padding-right: 10px;
      .item {

        .item-content {
          border-radius: 4px;
          box-shadow: 0 0 20px rgba(0,0,0,0.16);
          padding: 15px;
          margin: 10px;
          margin-bottom: 15px;
        }
        .item_header {
          height: 40px;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
          
          .item_header_title {
            line-height: 22px;
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2; /*要显示的行数*/
            -webkit-box-orient: vertical;
          }

          .item_header_logo {
            min-width: 40px;
            min-height: 40px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }

        .item_describe {
          padding: 12px 0 15px 0;
          height: 46px;
          line-height: 19px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #7c829d;
          span {
            margin-right: 15px;
            color: rgba(255, 255, 255, 0.5);
          }
          .item_describe_tag {
            width: 34px;
            height: 19px;
            margin-right: 15px;
            line-height: 21px;
            display: inline-block;
            text-align: center;
            background: #bee6eb;
            border-radius: 3px;
            font-size: 11px;
            color: #02576d;
          }
          .item_describe_tag2 {
            font-size: 11px;
            color: #666666;
          }
        }

        .item_honor {
          width: 100%;
          line-height: 30px;
          display: flex;
          justify-content: center;
          color: #02576D;
          font-size: 14px;
          font-weight: bold;
          padding: 7px 0 8px 0;
          background: rgba(2,87,109,0.1);
          border-radius: 4px;
          span {
            height: 15px;
            line-height: 19px;
            display: inline-block;
            padding-left: 7.8px;
            margin-right: 8.2px;
            border-left: 1px solid #fff;
          }
          .no_border {
            border: none;
            font-size: 13px;
            font-weight: bold;
          }
        }

        .item_footer {
          height: 34px;
          width: 100%;
          margin-top: 15px;

        .boxThree{
          display: flex;
          justify-content: space-between;
          .item_footer_item {
            width: 110px;
            height: 34px;
            line-height: 36px;
            text-align: center;
            background: #02576D;
            border-radius: 3px;
            font-size: 15px;
            color: #fff;
            cursor: pointer;
          }
          .nonactivated {
            background: #BAC2D1;
            color: rgba(255, 255, 255, 0.24);
          }
          }
        .boxTwo{
          display: flex;
          justify-content: space-between;
          .item_footer_item {
            width: 170px;
            height: 34px;
            line-height: 36px;
            text-align: center;
            background: #02576D;
            border-radius: 3px;
            font-size: 15px;
            color: #fff;
            cursor: pointer;
          }
          .nonactivated {
            background: #25293a;
            color: rgba(255, 255, 255, 0.24);
          }
          }
        .boxOne{
          display: flex;
          justify-content: space-between;
          .item_footer_item {
            width: 100%;
            height: 34px;
            line-height: 36px;
            text-align: center;
            background: #02576D;
            border-radius: 3px;
            font-size: 15px;
            color: #fff;
            cursor: pointer;
          }
          .nonactivated {
            background: #25293a;
            color: rgba(255, 255, 255, 0.24);
          }
          }
        }
      }
    }

  
  .shade_pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  .log_modal {
    width: 770px;
    height: 660px;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -385px;
    margin-top: -330px;
    background: #fff;
    z-index: 1001;
    padding: 30px;

    .log_close {
      width: 40px;
      position: absolute;
      top: -60px;
      right: 20px;
      cursor: pointer;
    }
    .user_box {
    }
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 30px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inherit;
  border-radius: 0;
  background: inherit;
}
::-webkit-scrollbar-thumb {
  border-radius: inherit;
  -webkit-box-shadow: inherit;
  background: rgba(220, 63, 62, 0.5);
}
</style>
